var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.requestStatus === 1)?_c('RequestLoading'):_vm._e(),(_vm.requestStatus === 2)?_c('RequestTimeOut'):_vm._e(),(_vm.requestStatus === 3)?_c('RequestError'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }